import { defineStore } from 'pinia';

export const useUserStore = defineStore('permissions', {
  state: () => ({
    user: {
      role:[]
    },
  }),
  getters: {
    permissions(state) {
      return state.user.role;
    },
  },
  actions: {
    checkPermissions(permission) {
      // Kiểm tra quyền
      return this.permissions.includes(permission);
    },
    async getUser(user){
      this.user.role = user.claims?.filter(e => e.checked)?.flatMap(e => e.claimType) || [];
    }
  },
 
});
